<template>
    <input-container
        :label="label"
        :assistive="assistive"
        :no-assistive="noAssistive"
        :max="max"
        :count="input ? input.length : 0"
        :char-counter="charCounter"
        :classes="classes"
        :body-styles="{ height: 'auto !important' }"
        :class="{ focused, disabled, invalid }">
            <template #container>
                <ul class="w-full m-0">
                    <InputTaskItem
                        v-for="(item, i) in input"
                        v-model="input[i]"
                        @add="add"
                        @remove="remove"
                        :key="i"
                        :index="i"
                        :max-length="maxLength+1"
                        :autofocus="i <= input.length"
                        :disabled="disabled"
                    />
                </ul>
            </template>
    </input-container>
</template>

<script>
import InputContainer from './input-container.vue';
import InputTaskItem from './input-task-item.vue';

export default {
  components: {
    InputContainer,
    InputTaskItem,
  },
  data() {
    const { value } = this;
    return {
      focused: false,
      input: value || [''],
    };
  },
  props: {
    noAssistive: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    enhancerLabel: {
      type: [Boolean, String],
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    clean: {
      type: Boolean,
      default: false,
    },
    value: {},
    label: {
      type: [String, Boolean],
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    assistive: {
      type: [String, Boolean],
      default: false,
    },
    error: {
      type: [Boolean, String, Array],
      default: false,
    },
    classes: {
      type: String,
      default: 'p-b-32',
    },
    sanitize: {
      type: Function,
      default: (v) => v,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },    
    reduce: {
      type: Function,
      default: (v) => v,
    },
    delay: {
      type: Number,
      default: 0,
    },
    max: {
      type: [String, Number],
      default: 120,
    },
    charCounter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCleanButton() {
      return !this.disabled && this.clean && this.value.length;
    },
    invalid() {
      return Boolean(this.error || this.error.length);
    },
  },
  watch: {
    input(input) {
      this.$emit('input', this.reduce(input));
    },
    value(value) {
      this.input = this.reduce(value);
    },
  },
  methods: {
    focus(focus) {
      this.focused = focus;
    },
    blur(blur) {
      this.focused = blur;
    },
    clear() {
      this.$refs.input.clear();
    },
    add() {
        this.input.push('');
    },
    remove(index) {
        if (this.input.length === 1) return;
        this.input.splice(index, 1);
    },
    reset() {
        this.input = [''];
    },
  },
  mounted() {
    this.input = this.reduce(this.value);
  },
};
</script>
